import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import Card from '../../../../components/card/Card';
import { ElectricVehicle } from '../../../../types';
import { LEVEL_2_CHARGING_RATE } from '../../../../utils/assumptions';
import { formatVehicleDisplayName } from '../../../../utils/formatters';
import AssumptionLineItem from './AssumptionLineItem';

type Props = {
  vehicle1: ElectricVehicle;
  vehicle2: ElectricVehicle;
};

export default function Level2ChargingAssumptions({ vehicle1, vehicle2 }: Props) {
  const { formatMessage } = useIntl();

  const isVehicle1BelowChargerRate = (vehicle1.acChargingPower || 0) < LEVEL_2_CHARGING_RATE;
  const isVehicle2BelowChargerRate = (vehicle2.acChargingPower || 0) < LEVEL_2_CHARGING_RATE;
  const isBothVehiclesAboveRate = !isVehicle1BelowChargerRate && !isVehicle2BelowChargerRate;

  const vehicle1ChargeRateMessage = isVehicle1BelowChargerRate
    ? formatMessage(
        { id: 'compare.assumptions.maxChargeRateDisclaimer' },
        { vehicle: formatVehicleDisplayName(vehicle1), chargeRate: vehicle1.acChargingPower },
      )
    : formatMessage(
        { id: 'compare.assumptions.normalChargeRateDisclaimer' },
        { vehicle: formatVehicleDisplayName(vehicle1), chargeRate: LEVEL_2_CHARGING_RATE },
      );

  const vehicle2ChargeRateMessage = isVehicle2BelowChargerRate
    ? formatMessage(
        { id: 'compare.assumptions.maxChargeRateDisclaimer' },
        { vehicle: formatVehicleDisplayName(vehicle2), chargeRate: vehicle2.acChargingPower },
      )
    : formatMessage(
        { id: 'compare.assumptions.normalChargeRateDisclaimer' },
        { vehicle: formatVehicleDisplayName(vehicle2), chargeRate: LEVEL_2_CHARGING_RATE },
      );

  return (
    <Card>
      <Box display="flex" flexDirection="column">
        <Typography variant="label1" mb={1}>
          {formatMessage({ id: 'compare.assumptions.header' })}
        </Typography>
        {isBothVehiclesAboveRate ? (
          <AssumptionLineItem
            label={formatMessage({ id: 'compare.assumptions.level2ChargingSpeed' })}
            value={formatMessage(
              { id: 'compare.assumptions.chargeRate' },
              { rate: LEVEL_2_CHARGING_RATE },
            )}
          />
        ) : (
          <Typography fontSize="0.75rem">
            {vehicle1ChargeRateMessage} {vehicle2ChargeRateMessage}
          </Typography>
        )}
      </Box>
    </Card>
  );
}
